import React from "react";
import MlDlCert from "../../assests/Certificates/Machine_Learning_Deep_Learning_IBM.pdf";
import IntroAiCert from "../../assests/Certificates/Intro_AI_IBM.pdf";
import AiEthicsCert from "../../assests/Certificates/AI_Ethics_SkillsBuild.pdf";
import NlpCert from "../../assests/Certificates/Karanveer Sidhu - NLP.pdf";
import AzureMlCert from "../../assests/Certificates/Karanveer Sidhu - Machine Learning.pdf";

const certifications = [
  {
    title: "Machine Learning & Deep Learning (MDL-212)",
    dates: "September 2025",
    detail: "IBM SkillsBuild – Artificial Intelligence Series",
    bullets: [
      "Gained practical knowledge of supervised learning, neural networks, and AI model training."
    ],
    tech: ["Machine Learning", "Deep Learning", "Neural Networks"],
    links: [{ label: "View certificate", href: MlDlCert }]
  },
  {
    title: "Introduction to AI (MDL-211)",
    dates: "September 2025",
    detail: "IBM SkillsBuild – Artificial Intelligence Series",
    bullets: [
      "Studied AI fundamentals including core concepts, applications, and how intelligent systems are built and evaluated."
    ],
    tech: ["Artificial Intelligence", "AI Fundamentals"],
    links: [{ label: "View certificate", href: IntroAiCert }]
  },
  {
    title: "AI Ethics (MDL-220)",
    dates: "September 2025",
    detail: "IBM SkillsBuild – Artificial Intelligence Series",
    bullets: [
      "Studied ethical principles for AI including fairness, accountability, and transparency."
    ],
    tech: ["AI Ethics", "Fairness", "Accountability"],
    links: [{ label: "View certificate", href: AiEthicsCert }]
  },
  {
    title: "Natural Language Processing Large Language Models",
    dates: "April 2025 – August 2025",
    detail: "10-week workshop series",
    bullets: [
      "Completed a workshop series covering NLP fundamentals, transformer architectures, text encoders, and large language model applications."
    ],
    tech: [
      "Python",
      "Hugging Face Transformers",
      "PyTorch",
      "spaCy",
      "NLTK",
      "BERT"
    ],
    links: [{ label: "View certificate", href: NlpCert }]
  },
  {
    title: "Microsoft Azure Machine Learning Model Manipulation",
    dates: "January 2025 – March 2025",
    detail: "Microsoft Azure Machine Learning (Cloud)",
    bullets: [
      "Built, trained, and deployed machine learning models on datasets through the creation of data pipelines."
    ],
    tech: ["Microsoft Azure ML", "Cloud", "Data Pipelines"],
    links: [{ label: "View certificate", href: AzureMlCert }]
  }
];

const Chip = ({ children }) => (
  <span className="rounded-md border border-gray-700 px-2 py-0.5 text-xs text-gray-300">
    {children}
  </span>
);

const Certifications = () => {
  return (
    <section id="certifications" className="bg-gray-900 text-gray-100 py-16">
      <div className="mx-auto max-w-5xl px-4">
        <h2 className="text-4xl font-bold text-white text-center">Certifications</h2>
        <p className="mt-3 text-center text-gray-400">
          Professional credentials in AI, NLP, and cloud machine learning.
        </p>

        <ol className="mt-10 relative border-l border-gray-700">
          {certifications.map((cert, i) => (
            <li key={i} className="mb-10 ml-4">
              <span className="absolute -left-2.5 flex h-5 w-5 items-center justify-center rounded-full bg-blue-600 ring-4 ring-gray-900" />

              <div className="rounded-xl border border-gray-800 bg-gray-850/50 p-5 shadow">
                <div className="flex flex-wrap items-baseline justify-between gap-2">
                  <h3 className="text-xl font-semibold text-white">{cert.title}</h3>
                  <span className="text-sm text-gray-400">{cert.dates}</span>
                </div>
                <p className="mt-1 text-gray-300">{cert.detail}</p>

                <ul className="mt-3 list-disc space-y-2 pl-5 text-sm text-gray-300">
                  {cert.bullets.map((b, j) => (
                    <li key={j}>{b}</li>
                  ))}
                </ul>

                <div className="mt-3 flex flex-wrap gap-2">
                  {cert.tech.map((t) => (
                    <Chip key={t}>{t}</Chip>
                  ))}
                </div>

                <div className="mt-4 flex flex-wrap gap-3">
                  {cert.links.map((link) => (
                    <a
                      key={link.label}
                      href={link.href}
                      target="_blank"
                      rel="noreferrer"
                      className="rounded-md bg-blue-600 px-3 py-1.5 text-sm text-white hover:bg-blue-700 transition"
                    >
                      {link.label}
                    </a>
                  ))}
                </div>
              </div>
            </li>
          ))}
        </ol>
      </div>
    </section>
  );
};

export default Certifications;
